import React, { useContext } from 'react';
import { Layout, Menu } from 'antd';
import { Link, Outlet } from 'react-router-dom';
import '../EigenschappenScreen/EigenschappenScreen.css';
import { ShoppingCartOutlined, HistoryOutlined, ProfileOutlined, UserOutlined, ContactsOutlined } from '@ant-design/icons';
import { authService, Role } from '../../../Services/auth.service';

const { Content, Sider } = Layout;

const AdminScreen = () => {
  // Haal de gebruikersinfo op uit de AuthContext
  const user = authService().currentUser() || null;
  // Bepaal of de gebruiker de rol "gebruikersbeheerder" heeft
  const isUserManager = user.rol === Role.Gebruikersbeheerder;
  // Bouw menu-items op basis van gebruikersrechten
  const menuItems = [
    { key: 'Bestelling', label: 'Bestelling', icon: <ShoppingCartOutlined />, children: [
      { key: '1', label: <Link to="/Admin/bestelling/ControleVoorstel">Controle voorstel</Link> },
      { key: '2', label: <Link to="/Admin/bestelling/ControleBestelling">Controle bestelling</Link> },
      { key: '2a', label: <Link to="/Admin/bestelling/Bestelling">Bestellen</Link> },
      {key: '9', label:<Link to="/Admin/Bestelling/extraProduct">Extra Product</Link>}
      
    ] },
    { key: 'Geschiedenis', label: 'Geschiedenis', icon: <HistoryOutlined />, children: [
      { key: '5', label: <Link to="/Admin/bestelling/VoorstelGeschiedenis">Kookgeschiedenis</Link> },
      { key: '5a', label: <Link to="/Admin/bestelling/BestellingsGeschiedenis">Bestelgeschiedenis</Link> },
    ] },
    { key: 'Menu', label: 'Menu', icon: <ProfileOutlined />, children: [
      { key: '6', label: <Link to="Leerkracht">Menu bestellen</Link> },
      { key: '7', label: <Link to="geplandelessen">Geplande lessen</Link> },
      { key: '8', label: <Link to="geschiedenis">Menu geschiedenis</Link> },
    ] },
    {key: '3', icon: <ContactsOutlined/>, label: <Link to="/Admin/Bestelling/MFC">MFC</Link>},
  ];
  
  // Voeg gebruikersbeheer item alleen toe als de gebruiker de juiste rol heeft
  if (isUserManager) {
    menuItems.push({ 
      key: 'Gebruikersbeheer', 
      label: <Link to="gebruikersbeheer">Gebruikersbeheer</Link>, 
      icon: <UserOutlined /> 
    });
  }

  return (
    <Layout className='volledig-scherm'>
      {/* Sidebar blijft staan */}
      <Sider className='sidebar'>
        <Menu mode="inline" defaultSelectedKeys={['1']} items={menuItems} />
      </Sider>
      {/* Dynamische Content Area */}
      <Layout>
        <Content className='content'>
          <Outlet /> {/* Dit zal de juiste component tonen op basis van de route */}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminScreen;